import { render } from "./Switch.vue?vue&type=template&id=25f94740"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"
script.render = render

export default script